<template>
    <SideFormSection>
        <template #title> Payment Settings </template>
        <template #subtitle>
            Enable payment processing and add prices in multiple currencies to
            this service.
        </template>
        <template #rawContent>
            <Card>
                <template #content>
                    <div class="space-y-8">
                        <div class="space-y-2">
                            <CardTitle
                                title="Prices"
                                iconName="dollar-sign"
                            />
                            <ServicePriceTable
                                :service="serviceAggregate.service"
                                :servicePrices="serviceAggregate.servicePrices"
                            />
                        </div>

                        <div class="space-y-2">
                            <CardTitle
                                title="Settings"
                                iconName="gears"
                            />
                            <ApiForm
                                method="POST"
                                :url="
                                    urlFactory.makeServiceUpdatePaymentSettingsUrl(
                                        serviceAggregate.service.id,
                                    )
                                "
                                ref="apiFormRef"
                            >
                                <ServicePaymentSettingsForm
                                    :paymentIntegrations="paymentIntegrations"
                                    :serviceAggregate="serviceAggregate"
                                    :errors="
                                        apiFormRef?.response?.getErrors() ??
                                        new ApiFormErrors({})
                                    "
                                />
                                <div class="flex justify-end">
                                    <Button
                                        @click="apiFormRef?.submit()"
                                        :loading="apiFormRef?.loading.valueOf()"
                                        color="dark"
                                        iconName="save"
                                    >
                                        Save
                                    </Button>
                                </div>
                            </ApiForm>
                        </div>
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType, ref } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'

    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import ServicePriceTable from '@/App/Service/Component/ServicePrice/ServicePriceTable.vue'
    import ServicePaymentSettingsForm from '@/App/Service/Component/ServicePrice/ServicePaymentSettingsForm.vue'

    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import CardTitle from '@/Shared/Component/CardTitle.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
        paymentIntegrations: {
            type: Array as PropType<Integration[]>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType | null>(null)
    const urlFactory = new UrlFactory()
</script>
